import React, { useEffect, useState } from 'react';
import { notification, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getRequest } from '../../api';
import './confirmEmail.css'; 
import emailIcon from '../../assets/images/email-push.png';

const CheckEmail = () => {
  const [messageApi, contextHolder] = notification.useNotification();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const signupRequest = async (token) => {
    setLoader(true);
    try {
      const response = await getRequest(`/user/confirm-email?token=${token}`);
      setLoader(false);

      if (response.error) {
        messageApi.error({
          message: 'Error',
          description: 'Error confirming email',
        });
        navigate('/signup'); 
      } else {
        messageApi.success({
          message: 'Success',
          description: 'Email confirmed successfully. You can now log in.',
        });
        navigate('/signin'); 
      }
    } catch (error) {
      messageApi.error({
        message: 'Error in processing request',
        description: error.error ? error.error : error.message,
      });
      navigate('/signup'); 
      setLoader(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      signupRequest(token);
    }
  }, []);

  return (
    <div className="check-email-container">
      {contextHolder}
      {loader ? (
        <div className="loader-container">
          <Spin />
        </div>
      ) : (
        <>
          <div className="email-icon-container">
            <img src={emailIcon} alt="Check Your Email" className="email-icon" />
          </div>
          <h1>Check Your Email</h1>
          <p>
            You’re all set! To activate your account please check your email and click on the link provided.
          </p>
        </>
      )}
    </div>
  );
};

export default CheckEmail;